







































import { Component, Vue, Watch, namespace } from 'nuxt-property-decorator';
// @ts-ignore
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import CloseVideoIcon from '@/assets/svg/close.vue.svg';
import { WAR_ROOM_COMMISSION_TOOLTIP as TOOLTIP_NAME } from '@/components/common/constants';

import CommissionBalanceQuery from '@/apollo/queries/CommissionBalance.query';

import type { CommissionBalance } from '@/types/graphql';

import RectIcon from './images/rect.vue.svg';
import VideoIcon from './images/video.vue.svg';
import CloseIcon from './images/close.vue.svg';

const UIStore = namespace('ui');
const BALANCE_CLASS = '.header-commission-balance';

@Component<WarRoomCommissionTooltip>({
  name: 'WarRoomCommissionTooltip',
  components: {
    RectIcon,
    VideoIcon,
    CloseIcon,
    CloseVideoIcon,
  },
  apollo: {
    commissionBalance: {
      query: CommissionBalanceQuery,
      skip() {
        return !this.$auth.loggedIn;
      },
    },
  },
  beforeMount() {
    if (this.$tooltip.isPresent(TOOLTIP_NAME)) {
      return;
    }

    this.interval = setInterval(() => {
      if (document.querySelector(BALANCE_CLASS)) {
        this.calculatePosition();
        window.addEventListener('resize', this.calculatePosition);

        disableBodyScroll(this.$refs.window);

        window.scrollTo(0, 0);
        clearInterval(this.interval);
        this.$analytics.logEvent('war-room__common__earn-commission-tooltip__shown');
      }
    }, 100);
  },
  beforeDestroy() {
    this.handleDestroy();
  },
})
export default class WarRoomCommissionTooltip extends Vue {
  protected commissionBalance!: CommissionBalance;

  protected interval!: NodeJS.Timeout;
  protected tooltipLeft = 0;
  protected videoOpened = false;

  @UIStore.State('isCommissionDropdownOpen') isCommissionDropdownOpen!: boolean;
  @UIStore.State('onboardingTooltips') onboardingTooltips!: Record<string, boolean>;
  @UIStore.Mutation('closeOnboardingTooltip') closeOnboardingTooltip!: (tooltip: string) => void;

  @Watch('isCommissionDropdownOpen')
  private isCommissionDropdownOpenWatch(newVal: boolean) {
    if (this.visible && newVal === true) {
      this.handleClose();
    }
  }

  get visible() {
    return this.onboardingTooltips[TOOLTIP_NAME];
  }

  get balance() {
    return this.commissionBalance.currentBalance;
  }

  get referralCount() {
    // @ts-ignore
    return this.$auth.user?.warRoomReferralCount;
  }

  get hintText() {
    const referralHint = this.referralCount
      ? `, additionally <span class="war-room-commission-tooltip__tooltip-desc--emph">${this.referralCount} of your referrals</span> just signed up`
      : '';

    return `You've already earned <span class="war-room-commission-tooltip__tooltip-desc--emph">${this.balance} Commission</span> for signing up for the War Room${referralHint}! Curious about what Commission is and what you can do with it? Check out the video below.`;
  }

  calculatePosition() {
    const ratingEl = document.querySelector(BALANCE_CLASS);
    if (ratingEl) {
      const clientRect = ratingEl.getBoundingClientRect();
      this.tooltipLeft = clientRect.left + clientRect.width / 2 - 264 + 38;
    }
  }

  handleClose() {
    this.closeOnboardingTooltip(TOOLTIP_NAME);
    this.$tooltip.close(TOOLTIP_NAME);

    this.handleDestroy();
  }

  handleDestroy() {
    window.removeEventListener('resize', this.calculatePosition);
    clearInterval(this.interval);
    clearAllBodyScrollLocks();
  }

  handleOpenVideo() {
    this.videoOpened = true;
    this.$analytics.logEvent('war-room__common__earn-commission-tooltip-video-button__click');
  }
}
